import { createFileRoute, Outlet } from '@tanstack/react-router';
import type { JSX } from 'react';

import { RiskManagementSidebar } from '@/app/navigation/RiskManagementSidebar';
import type { PageStaticData } from '@/shared/routing';
import { SidebarRouteLayout } from '@/shared/ui/PageLayoutCollapsibleSidebar';

// Every Risk management page sits beside its sidebar.
export const Route = createFileRoute('/_authenticated/risk-management')({
    // Each page checks who may open it.
    staticData: { access: 'authenticated', chrome: 'none' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return (
        <SidebarRouteLayout sidebar={<RiskManagementSidebar />}>
            <Outlet />
        </SidebarRouteLayout>
    );
}
